import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { FormulaItemEntity } from './formula-item.entity';

export interface IFormulaListExtra
	extends IListColumnConfig<FormulaItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface IFormulaListEntity extends IListAttrs<FormulaItemEntity> {
	availableColumns: Map<string, IFormulaListExtra>;
}

const entityDefaults: IFormulaListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class FormulaListEntity
	implements
		IFormulaListEntity,
		IListOperations<FormulaListEntity, FormulaItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IFormulaListExtra>
	): FormulaListEntity {
		const inst = new FormulaListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IFormulaListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<FormulaItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, FormulaItemEntity>): FormulaListEntity {
		return produce(this, (draft: FormulaListEntity) => {
			draft.elements = elems;
		});
	}
}
